module.exports = __webpack_public_path__ + "img/worksbot_img19121305.3cc17842.jpg";